import addAgencyIdAndExecuteFinishToRender from 'utils/addAgencyIdAndExecuteFinishToRender'
import setPlanOutOfViewHandler from './components/plan/setPlanOutOfViewHandler'
import enableSaveQuoteAgent from 'core/controllerPlans/enableSaveQuoteAgent'
import detailsPlanFromAgent from 'core/controllerPlans/detailsPlanFromAgent'
import { propAccessor } from '@hc-frontend/utils'
import isSalesCenterAgent from 'utils/pivot/agent/isSalesCenterAgent'
import setScrollToHandler from 'core/DOM/setScrollToHandler'
import getURLProfile from 'utils/pivot/member/getURLProfile'
import registryListenersDOM from './registryListenersDOM'
import individualState from 'core/DOM/individualState'
import { IS_AGENT, IS_SHORT_TERM } from 'core/constants/environment'
import saveThisQuote from 'pug/mixins/saveThisQuote'
import isEpicPlan from 'utils/pivot/plan/isEpicPlan'
import toggleClass from 'utils/DOM/toggleClass'
import textContent from 'utils/DOM/textContent'
import moneyFormat from 'utils/format/money'
import curry from 'utils/functional/curry'
import { DETAILS } from 'sites/routes'
import config from './config'
// For new ISC details page style
import setTooltips from './utils/setTooltips'
import configureDetails from './utils/configureDetails'
import handleAddonClasses from './utils/handleAddonClasses'
import { DENTAL, LATITUDE } from 'core/constants/products'
import renderISCStyle from './utils/renderISCStyle'
import renderLegacyStyle from './utils/renderLegacyStyle'
import addFirstCignaRef from '../welcome-back-quote/addFirstCignaRef'
import updateAddons from 'sites/pivothealth.com/fixed-benefit-medical/consumer/quotes/utils/updateAddons'
import clickEventName from 'utils/DOM/clickEventName'
import { preventOnCloseEvent } from 'core/services/onClose'
import isBTMPlan from 'utils/pivot/plan/isBTMPlan'
import initSmartly from 'core/initPage/absmartly'
import { redirectToSTM } from 'core/controllerPlansBTM/forbidBTM'
import setMichiganEpicPlanDisclaimer from 'utils/pivot/disclaimer/setMichiganEpicPlanDisclaimer'
import getCommissionDisclosureLink from 'sites/pivothealth.com/short-term-health-insurance/consumer/start-application/utils/getCommissionDisclosureLink'
import forEach from 'utils/DOM/forEach'
import renderAssistedNotice from 'core/DOM/renderAssistedNotice'
import prepareDataToTrack from './prepareDataToTrack'
import registerSnowplowListeners from './registerSnowplowListeners'
import isSureCarePlan from 'utils/pivot/plan/isSureCarePlan'
import isClicPlan from 'utils/pivot/plan/isClicPlan'

const asMoney = moneyFormat

async function initDOM(state) {
  const {
    hcStorage,
    plansByType,
    prices,
    dentalPlanId,
    visionPlanId,
    supplementalId,
    latitudeId,
    plans,
    plan,
    planId,
    hasDentalActive,
    planHasChanged,
    externalPlans,
    externalPlanSelected
  } = state
  // Setup GTM and add userId to dataLayer
  window.dataLayerPushVariable({
    user_id: hcStorage.healthcareUserId
  })

  $('body')
    .on(clickEventName, '.primaryButton', function () {
      preventOnCloseEvent()
    })
    .on(clickEventName, '.isc-add-plan', function () {
      preventOnCloseEvent()
    })

  const smartlySDK = initSmartly()

  let disableBTM = 1
  if (smartlySDK) {
    smartlySDK.track('ph_display_details')
    smartlySDK.track('ph_display_start-application')
    smartlySDK.publish()
    disableBTM = smartlySDK.treatment('PH_BTM_REDIRECT')
  }

  const isBTM = isBTMPlan(plan)

  redirectToSTM(isBTM, disableBTM)

  if (state.renderISCDetails === true) {
    toggleClass('#js-plan-info', 'd-none', true)
    toggleClass('#summary-details-prices', 'd-none', true)
    await renderISCStyle(state)
    toggleClass('body', 'show-loading', false)
    toggleClass('.wrap-info', 'd-none', true)
    updateAddons({ ...state, addonsByPlan: { [planId]: state.addOns } })
  } else {
    toggleClass('#plans-wrap', 'd-none', true)
    toggleClass('#js-plan-info', 'd-none', false)
    toggleClass('#summary-details-prices', 'd-none', false)
    renderLegacyStyle(state)
  }

  toggleClass('.plan-switch__wrap', 'd-none', !planHasChanged)

  addFirstCignaRef()

  handleAddonClasses({
    dentalPlanId,
    visionPlanId,
    supplementalId,
    latitudeId,
    plans,
    hasDentalActive,
    externalPlans,
    externalPlanSelected
  })

  // cigna section
  const isCigna = plan.coreBenefits.networkProvider === 'cigna'
  toggleClass('body', 'cigna', isCigna)
  toggleClass('.js-statistics-show', 'd-none', isCigna)

  toggleClass(
    '.disclaimer__dental',
    'd-none',
    !(propAccessor(plansByType, `${DENTAL}`, []).length > 0)
  )
  toggleClass(
    '.disclaimer__latitude',
    'd-none',
    !(propAccessor(plansByType, `${LATITUDE}`, []).length > 0)
  )
  setMichiganEpicPlanDisclaimer(state)

  const isEpic = isEpicPlan(plan)
  const isClic = isClicPlan(plan)
  const isSureCare = isSureCarePlan(plan)

  toggleClass(document.body, 'nric', isEpic)
  toggleClass(document.body, 'clic', isClic)
  toggleClass(document.body, 'sure_care', isSureCare)

  // plan information
  textContent('.js-prices-plan', prices.plan)
  textContent('.js-prices-fee', asMoney(prices.subscriptionFeeNumber))
  textContent('.js-prices-total-without-fee', state.prices.total)
  individualState(hcStorage.location.state_acronym)

  if (plan.multiCarrierPlan) {
    // TODO: Verify if more complex logic is needed for multi-carrier period label
    const policyDuration = plan.durations[0].policyDuration
    textContent('.js-plan-end', `${policyDuration} days`)
  } else {
    textContent('.js-plan-end', `${state.periodRange.days}`)
  }

  registryListenersDOM()
  setScrollToHandler(125)

  // init controls
  setPlanOutOfViewHandler()
  setTooltips(state)

  if (IS_AGENT) {
    isSalesCenterAgent(hcStorage.agent_id).then(salesCenterAgent => {
      enableSaveQuoteAgent(() => {
        toggleClass('.js-save-this-quote-agent', 'd-none', false)
      }, curry(detailsPlanFromAgent)({ config, path: DETAILS, salesCenterAgent }))
    })

    renderAssistedNotice(hcStorage.location)
  } else {
    saveThisQuote({
      getPath: () => `${DETAILS}?${getURLProfile({ placement: config.placement })}`,
      placement: config.placement,
      tags: [config.tagMaropost],
      defaultEmail: hcStorage.contact.email_address || hcStorage.members[0].email
    })
  }
  if (IS_SHORT_TERM) {
    const commissionDisclosureLink = getCommissionDisclosureLink(planId)

    forEach('.link-commission-disclosure', node => {
      node.href = commissionDisclosureLink
    })
    toggleClass('.limitation-exclusions-footer', 'd-block', true)
  }
  configureDetails(state).then(addAgencyIdAndExecuteFinishToRender)
  prepareDataToTrack(state)
  registerSnowplowListeners()
}

export default initDOM
